import { render, staticRenderFns } from "./phone-confirm-form.vue?vue&type=template&id=5004f118&scoped=true"
import script from "./phone-confirm-form.vue?vue&type=script&lang=js"
export * from "./phone-confirm-form.vue?vue&type=script&lang=js"
import style0 from "vue-tel-input/dist/vue-tel-input.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5004f118",
  null
  
)

export default component.exports